export default __webpack_public_path__ + "static/media/sounds/ran_numbers_four_alyx.mp3";